import { useFormContext } from 'react-hook-form'

import { useServices } from '@percent/product-nomination-form/hooks'
import { HostedFormStep } from '../../HostedForm.types'
import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData'

import { SubmitNominationFormPayload } from '@percent/product-nomination-form/api/nominationForm/nominationForm.types'
import { useMutation } from '@percent/utility'
import { Terms } from './Terms'

export const TermsContainer = () => {
  const { handleNext, country } = useValidationStepData()
  const { handleSubmit } = useFormContext<SubmitNominationFormPayload>()
  const { nominationService } = useServices()
  const [{ isPending, error }, { apiFunc }] = useMutation(
    nominationService.submitNominationForm,
    () => {
      handleNext(HostedFormStep.COMPLETE)
    }
  )

  const handleFormSubmit = handleSubmit((value) => {
    if ('organisationId' in value) apiFunc(value)
    else apiFunc({ ...value, countryCode: country })
  })

  return (
    <Terms
      handleFormSubmit={handleFormSubmit}
      isLoading={isPending}
      isError={!!error}
    />
  )
}
